import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import history from 'utils/history';
import { getHypertestJobList } from '../../store/actions/hypertestJobList';
import { updateQuickStartStatus } from '../../store/actions/hypertestJobDetail';
import { sendAmplitudeEvents } from '../../utils/common';
import { EventNames } from '../../utils/events';

import { Path } from 'constants/routes';

const useViewTestResult = () => {
  const [showNoTestError, setShowNoTestError] = useState(false);
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.userInfo?.userInfo);
  const visual = useSelector((state) => state.userInfo?.visual);

  const currentConfiguration = useSelector(
    (state) => state.onboarding?.currentConfiguration
  );
  const currentConfigurationYamlBased = useSelector(
    (state) => state.onboarding?.currentConfigurationYamlBased
  );
  const auth = {
    username: userInfo.data && userInfo.data.username,
    password: userInfo.data && userInfo.data.apiToken,
  };
  let isYamlPage = window.location.pathname.indexOf('custom') !== -1;
  const getJobList = () => {
    dispatch(
      getHypertestJobList({
        auth: auth,
      })
    )
      .then((res) => {
        let data = res && res.payload && res.payload.data;
        if (data && data.length) {
          if (isYamlPage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_REDIRECT_SUCCESS_YAML_PAGE,
              {
                status: 'success',
                'cli os': currentConfiguration?.conciergePlatform,
                'yaml os': currentConfiguration?.platform,
                concurrency: currentConfigurationYamlBased?.concurrency,
                retry: currentConfigurationYamlBased?.retry,
                timeout: currentConfigurationYamlBased?.timeout,
              }
            );
          } else {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_REDIRECT_SUCCESS_SAMPLE_PAGE,
              {
                status: 'success',
                'cli os': currentConfiguration?.conciergePlatform,
                'yaml os': currentConfiguration?.platform,
              }
            );
          }
          if (visual && visual.isNewUser) {
            dispatch(updateQuickStartStatus(true));
          }
          showNoTestError && setShowNoTestError(false);
          history.push(Path.ROOT);
        } else {
          setShowNoTestError(true);
        }
        if (res && res.error) {
          if (isYamlPage) {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_REDIRECT_SUCCESS_YAML_PAGE,
              {
                status: 'fail',
                'cli os': currentConfiguration?.conciergePlatform,
                'yaml os': currentConfiguration?.platform,
                concurrency: currentConfigurationYamlBased?.concurrency,
                retry: currentConfigurationYamlBased?.retry,
                timeout: currentConfigurationYamlBased?.timeout,
              }
            );
          } else {
            sendAmplitudeEvents(
              EventNames.HYP_ONBOARDING_REDIRECT_SUCCESS_SAMPLE_PAGE,
              {
                status: 'fail',
                'cli os': currentConfiguration?.conciergePlatform,
                'yaml os': currentConfiguration?.platform,
              }
            );
          }
        }
      })
      .catch((err) => {
        console.log('error', err);
        if (isYamlPage) {
          sendAmplitudeEvents(
            EventNames.HYP_ONBOARDING_REDIRECT_SUCCESS_YAML_PAGE,
            {
              status: 'fail',
              'cli os': currentConfiguration?.conciergePlatform,
              'yaml os': currentConfiguration?.platform,
              concurrency: currentConfigurationYamlBased?.concurrency,
              retry: currentConfigurationYamlBased?.retry,
              timeout: currentConfigurationYamlBased?.timeout,
            }
          );
        } else {
          sendAmplitudeEvents(
            EventNames.HYP_ONBOARDING_REDIRECT_SUCCESS_SAMPLE_PAGE,
            {
              status: 'fail',
              'cli os': currentConfiguration?.conciergePlatform,
              'yaml os': currentConfiguration?.platform,
            }
          );
        }
      });
  };
  function handleDocLinkClick() {
    sendAmplitudeEvents(
      isYamlPage
        ? EventNames.HYP_ONBOARDING_VIEW_DOC_VIEW_TEST_RESULT_YAML
        : EventNames.HYP_ONBOARDING_VIEW_DOC_VIEW_TEST_RESULT,
      {
        redirectTo: process.env.REACT_APP_HYPERTEST_DOCUMENTAION_LINK,
      }
    );
  }
  return {
    getJobList,
    currentConfiguration,
    handleDocLinkClick,
    showNoTestError,
  };
};

export default useViewTestResult;
